import { Component, effect, inject, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { CourseFacade } from '@app/store/course';
import { AssessmentFacade } from '@app/store/assessment';
import { DeleteButtonComponent } from './delete-button/delete-button.component';
import { EntityListComponent, MaterialListViewComponent, MediaImageComponent, UnavailableComponent, ValueNameComponent } from '@shared/components';

@Component({
    selector: 'app-course-view-modal',
    templateUrl: './view.component.html',
    styleUrls: ['./view.component.css'],
    imports: [
        TranslateModule,
        ButtonModule,
        DeleteButtonComponent,
        EntityListComponent,
        MaterialListViewComponent,
        MediaImageComponent,
        UnavailableComponent,
        ValueNameComponent,
    ],
})
export class ViewComponent implements OnDestroy {
    private readonly router = inject(Router);
    private readonly route = inject(ActivatedRoute);
    private readonly courseFacade = inject(CourseFacade);
    readonly assessmentFacade = inject(AssessmentFacade);

    readonly course = this.courseFacade.course;
    readonly loading = this.courseFacade.loading;
    readonly error = this.courseFacade.error;
    readonly saving = this.courseFacade.saving;

    constructor() {
        const id = this.route.parent?.snapshot.params['id'];
        if (id) {
            this.courseFacade.getCourse(id);
            this.assessmentFacade.getAssessment(id);
        }

        effect(() => {
            if (this.courseFacade.saved()) {
                this.close({ replaceUrl: !this.courseFacade.course() });
            }
        });
    }

    ngOnDestroy(): void {
        this.courseFacade.clear();
        this.assessmentFacade.clear();
    }

    onEdit(): void {
        const course = this.course();
        if (course) {
            this.router.navigate([{ outlets: { modal: ['courses', 'edit', course.id] } }]);
        }
    }

    close({ replaceUrl } = { replaceUrl: false }): void {
        this.router.navigate([{ outlets: { modal: null } }], { replaceUrl });
    }
}
